declare global {
  interface Window {
    dataLayer: any;
  }
}

export const GoogleAnalyticsTag = (
  eventName?: string,
  params?: Record<string, unknown>
) => {
  const analyticsParameters = {
    ...params,
  };
  const payload = Object.assign(
    analyticsParameters,
    eventName ? { event_name: eventName } : {}
  );
  window?.dataLayer?.push(payload);
};

export const DispatchInteractUser = (
  email: string,
  modules: string,
  profile: string
) => {
  GoogleAnalyticsTag("", {
    cd_id: email,
    cd_modulo: modules,
    cd_perfil: profile,
  });
};
